import { match } from 'ts-pattern';

import { ControlledPageContainer } from '../CoreLayout/components/ContentContainer';
import { PageContentContainer } from '../CoreLayout/types/pages';
import usePageProps from '../hooks/usePageProps';

import './isolated-layout.scss';

export default function IsolatedLayout({ children }) {
  const { pageContentContainer } = usePageProps();

  const pageContent = match(pageContentContainer)
    .with(PageContentContainer.FREE_FORM, () => children)
    .with(PageContentContainer.CONTROLLED, () => <ControlledPageContainer>{children}</ControlledPageContainer>)
    .exhaustive();
  return (
    <div className="isolated-layout">
      <div className="isolated-layout__children">{pageContent}</div>
    </div>
  );
}
